import { Auth } from 'aws-amplify';
import { useAtom, useAtomValue } from 'jotai';
import logger from '~logger';
import {
  cognitoUserAtom,
  defaultUserAuthenticated,
  isAuthenticatedAtom,
  isLoadingAtom,
  userAuthenticatedAtom,
} from './auth.state';

export const useAuth = () => {
  const [cognitoUser, setCognitoUser] = useAtom(cognitoUserAtom);
  const [isAuthenticated, setIsAuthenticated] = useAtom(isAuthenticatedAtom);
  const isLoading = useAtomValue(isLoadingAtom);
  const [userAuthenticated, setUserAuthenticated] = useAtom(
    userAuthenticatedAtom,
  );

  const signOut = async () => {
    try {
      await Auth.signOut();
      // Reset state after successful sign out
      setCognitoUser(null);
      setUserAuthenticated(defaultUserAuthenticated);
      setIsAuthenticated(false);
    } catch (error) {
      logger.error('Error signing out:', error);
    }
  };

  return {
    cognitoUser,
    setCognitoUser,
    userAuthenticated,
    isAuthenticated,
    isLoading,
    signOut,
  };
};
